import { NavItemType } from "shared/Navigation/NavigationItem";
import ncNanoId from "utils/ncNanoId";

export const NAVIGATION_DEMO: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/about",
    name: "About",
  },
  {
    id: ncNanoId(),
    href: "/faq",
    name: "FAQs",
  },
  {
    id: ncNanoId(),
    href: "/blog",
    name: "Blog",
  },
];
